var en = function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n,
      n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
  if (ord) return (n10 == 1 && n100 != 11) ? 'one'
      : (n10 == 2 && n100 != 12) ? 'two'
      : (n10 == 3 && n100 != 13) ? 'few'
      : 'other';
  return (n == 1 && v0) ? 'one' : 'other';
};
var number = function (value, name, offset) {
  if (!offset) return value;
  if (isNaN(value)) throw new Error("Can't apply offset:" + offset + ' to argument `' + name + '` with non-numerical value ' + JSON.stringify(value) + '.');
  return value - offset;
};
var plural = function (value, offset, lcfunc, data, isOrdinal) {
  if ({}.hasOwnProperty.call(data, value)) return data[value];
  if (offset) value -= offset;
  var key = lcfunc(value, isOrdinal);
  return key in data ? data[key] : data.other;
};
var select = function (value, data) {
  return {}.hasOwnProperty.call(data, value) ? data[value] : data.other;
};

module.exports = {
  generic: {
    results: function(d) { return plural(d.copy, 0, en, { "0": "검색 결과 0개 ", "1": "검색 결과 1개", other: "검색 결과 " + number(d.copy, "copy") + "개" }); }
  },
  search: {
    title: function(d) { return "검색 결과"; },
    results: function(d) { return "“" + d.searchTerm + "”"; }
  },
  product: {
    notStockedOnLine: function(d) { return "죄송합니다. 이 아이템은 구매할 수 없습니다."; },
    productCode: function(d) { return "상품 코드"; },
    soldOut: function(d) { return "죄송합니다. 현재 이 아이템은 구매가 불가합니다. 이 스타일을 계속 주시하여 재입고 시 놓치지 마세요."; },
    buyableFalse: function(d) { return "죄송합니다. 이 아이템은 구매할 수 없습니다."; },
    unavailableProduct: function(d) { return "죄송합니다. 이 아이템은 구매할 수 없습니다."; },
    shippingRestriction: function(d) { return "죄송합니다. 이 아이템은 현재 고객님의 위치에서 구매가 불가합니다."; },
    restrictedToEip: function(d) { return "죄송합니다. 현재 이 아이템은 구매가 불가합니다. 위시리스트에 추가하여 이 스타일을 계속 주시하세요."; },
    doNotForgetToAddToWishlistMessage: function(d) { return "잊지 말고 위시리스트에 아이템을 추가하세요"; },
    shippingRestrictionsNotificationMessage: function(d) { return "배송 제한이 적용될 수 있습니다. [자세히 보기](/" + d.locale + "/content/help/delivery/)"; },
    needAdvice: function(d) { return "도움이 필요하신가요?"; },
    needAdviceCTA: function(d) { return "고객센터에 문의하세요"; },
    finalSaleNotification: function(d) { return "파이널 세일 - 이 아이템은 반품이 불가합니다."; },
    genericMessage: function(d) { return ""; },
    Brand: function(d) { return "브랜드"; },
    Illustrative: function(d) { return "예시"; },
    productTitle: function(d) { return "제품명"; }
  },
  considered: {
    badge: function(d) { return "지속 가능"; },
    consideredAccordion: function(d) { return "고객이 책임감 있는 패션을 보다 쉽게 접할 수 있도록 하기 위한 노력의 일환인 지속 가능한 셀렉션을 통해 이 아이템을 소개하게 되어 기쁩니다."; },
    actionText: function(d) { return "자세히 알아보기"; },
    href: function(d) { return "/editorial/our-considered-pledge"; },
    consideredAttributesTitle: function(d) { return "지속 가능한 이유는 무엇인가요?"; },
    consideredDelivery: function(d) { return "이는 현재 탄소 발자국이 가장 낮은 배송 옵션입니다."; },
    consideredFilters: function(d) { return "모든 지속 가능한 아이템 보기"; }
  },
  colourAndSize: {
    colour: function(d) { return " 컬러"; },
    size: function(d) { return " 사이즈"; },
    button1: function(d) { return " 안녕하세요"; },
    button2: function(d) { return " 안녕하세요"; },
    line1: function(d) { return " 안녕하세요"; },
    line2: function(d) { return " 안녕하세요"; }
  },
  pagination: {
    first: function(d) { return " 처음"; },
    previous: function(d) { return " 이전"; },
    next: function(d) { return " 다음"; },
    last: function(d) { return " 마지막"; },
    status: function(d) { return " " + d.currentPage + "/" + d.totalPages + " 페이지"; }
  },
  contactUsCTA: {
    personalShopper: {
      title: function(d) { return " 이 아이템의 웨이팅 리스트에 이름을 올리시려면 퍼스널 쇼핑 팀에 말씀하세요."; },
      titleAssignedPS: function(d) { return " 이 아이템의 웨이팅 리스트에 이름을 올리시려면 " + d.name + "에게 말씀하세요."; },
      emailLabel: function(d) { return " 이메일"; },
      emailStructure: {
        subject: function(d) { return " " + d.name + " 웨이팅 리스트에 이름을 올리고 싶습니다."; },
        body: function(d) { return " 이 상품의 웨이팅 리스트에 이름을 올리고 싶습니다.  " + d.url; }
      }
    },
    sizeAndFit: {
      title: function(d) { return " 어떤 사이즈를 구매할 지 망설이시나요?"; },
      titleEip: function(d) { return " 퍼스널 쇼핑 팀이 언제든지 상세한 상품 정보를 제공해 드립니다."; },
      titlePersonalShopper: function(d) { return " 고객님의 퍼스널 쇼퍼가 언제든지 상세한 상품 정보를 제공해 드립니다."; },
      emailLabel: function(d) { return " 이메일"; },
      emailStructure: {
        subject: function(d) { return " " + d.name + "에 대한 조언을 얻고 싶습니다."; },
        body: function(d) { return " 이 상품의 사이즈에 관한 질문이 있습니다.  " + d.url; }
      }
    },
    badge: function(d) { return " 퍼스널 쇼퍼에게 문의"; },
    eip: {
      soldOutOnline: {
        title: function(d) { return " 대체할 상품을 찾는 데 도움이 필요하시면 퍼스널 쇼핑 팀에 문의하세요."; },
        titleAssignedPS: function(d) { return " 대체할 상품을 찾는 데 도움이 필요하시면 " + d.name + "에게 문의하세요."; },
        emailLabel: function(d) { return " 이메일"; },
        emailStructure: {
          subject: function(d) { return " " + d.name + "(품절)을/를 대체할 상품이 궁금합니다."; },
          body: function(d) { return " 품절된 상품을 대체할 것을 찾는 데 도움이 필요합니다.  " + d.url; }
        }
      },
      notStockedOnline: {
        title: function(d) { return " 이 아이템의 구매에 대해서는 퍼스널 쇼핑 팀에 문의하세요."; },
        titleAssignedPS: function(d) { return " 이 아이템의 구매에 대해서는 " + d.name + "에게 문의하세요."; },
        emailLabel: function(d) { return " 이메일"; },
        emailStructure: {
          subject: function(d) { return " " + d.name + "을/를 구매하고 싶습니다."; },
          body: function(d) { return " 이 상품을 구매하고 싶습니다.  " + d.url; }
        }
      },
      buyableFalse: {
        title: function(d) { return " 이 아이템의 구매에 대해서는 퍼스널 쇼핑 팀에 문의하세요."; },
        titleAssignedPS: function(d) { return " 이 아이템의 구매에 대해서는 " + d.name + "에게 문의하세요."; },
        emailLabel: function(d) { return " 이메일"; },
        emailStructure: {
          subject: function(d) { return " " + d.name + "을/를 구매하고 싶습니다."; },
          body: function(d) { return " 이 상품을 구매하고 싶습니다.  " + d.url; }
        }
      },
      shippingRestricted: {
        title: function(d) { return " 주문하는 데 도움이 필요하시면 퍼스널 쇼핑 팀에 문의하세요."; },
        titleAssignedPS: function(d) { return " 주문하는 데 도움이 필요하시면 " + d.name + "에게 문의하세요."; },
        emailLabel: function(d) { return " 이메일"; },
        emailStructure: {
          subject: function(d) { return " " + d.name + "을/를 주문하는 데 도움이 필요합니다."; },
          body: function(d) { return " 이 상품을 주문하는 데 도움이 필요합니다.  " + d.url; }
        }
      },
      "default": {
        title: function(d) { return " 사이즈를 찾는 데 어려움이 있거나 사이즈를 선택하는 데 조언이 필요하신가요? 퍼스널 쇼핑 팀이 도와드리겠습니다."; },
        titleAssignedPS: function(d) { return " 사이즈를 찾는 데 어려움이 있거나 사이즈를 선택하는 데 조언이 필요하신가요? " + d.name + "이/가 도와드리겠습니다."; },
        emailLabel: function(d) { return " 이메일"; },
        emailStructure: {
          subject: function(d) { return " " + d.name + " 직원의 도움이 필요합니다."; },
          body: function(d) { return " 도움이 필요합니다.  " + d.url; }
        }
      },
      badge: function(d) { return " 퍼스널 쇼퍼에게 문의"; }
    }
  },
  ctaButtons: {
    goToWishlist: function(d) { return " 위시리스트로 이동"; },
    addToWishlist: function(d) { return " 위시리스트에 추가"; },
    addToWishlistLoading: function(d) { return " 위시리스트에 추가 중..."; },
    addToBag: function(d) { return " 쇼핑백에 추가"; },
    goToBag: function(d) { return " 쇼핑백으로 이동"; },
    addToBagLoading: function(d) { return " 쇼핑백에 추가 중..."; },
    viewShoppingBag: function(d) { return " 쇼핑백 보기"; },
    viewMoreDetails: function(d) { return "상품 상세 정보"; }
  },
  price: {
    discountPercentage: function(d) { return "(-" + d.discountPercentage + "%)"; },
    discountPrice: function(d) { return " 할인 가격"; },
    currencyExchange: function(d) { return " (약 " + d.exchangeCurrency + " " + d.exchangePrice + ")"; },
    ddpInformation: function(d) { return " (세금 및 관세 포함)"; },
    wasPriceOriginal: function(d) { return "RRP: " + d.wasPrice; },
    wasPrice: function(d) { return "RRP:"; },
    originalPrice: function(d) { return "정가:"; },
    priceInformation: {
      title: function(d) { return "가격 정보"; },
      subtitle: function(d) { return "THE OUTNET 가격 표시에 익숙해지기:"; },
      descriptionRRPWithoutMinimumMessage: function(d) { return "**1. 현재가:**\nTHE OUTNET 앱 및 웹사이트에서만 제공되는 제품 가격\n\n**2. RRP:**\n제조업체의 권장 소매 가격\n\n[자세히 보기](" + d.link + ")"; },
      descriptionOriginalPriceWithoutMinimumMessage: function(d) { return "**1. 현재가:**\nTHE OUTNET 앱 및 웹사이트에서만 제공되는 제품 가격\n\n**2. 정가:**\nTHE OUTNET 앱 및 웹사이트에 해당 아이템이 처음 등록된 가격\n\n[자세히 보기](" + d.link + ")"; }
    }
  },
  productListing: {
    unselectAll: function(d) { return " 전체 선택 해제"; },
    allSelected: function(d) { return " 전체"; },
    numberSelected: function(d) { return " " + d.number + "개 선택됨"; },
    refine: function(d) { return " 필터"; },
    priceFilter: {
      under: function(d) { return d.price; },
      over: function(d) { return d.price; }
    },
    apply: function(d) { return " 적용"; },
    clearFilters: function(d) { return " 필터 해제"; },
    sortBy: function(d) { return " 정렬"; },
    topDesignersThisWeek: function(d) { return " 이번 주 탑 디자이너"; },
    azDesigners: function(d) { return " 디자이너 이름순"; },
    searchDesigner: function(d) { return " 디자이너 검색"; },
    noResultsSearch: function(d) { return " \\" + d.searchTerm + "\\에 대한 검색 결과가 없습니다. 다시 시도하세요."; },
    emptyList: function(d) { return " " + select(d.pageType, { MARK_DOWN: "세일 종료", DESIGNER: "뉴 시즌 상품 곧 출시", SEARCH: d.query + "에 대한 검색 결과가 없습니다.", other: "검색된 아이템이 없습니다." }); },
    emptyListCopy: function(d) { return " " + select(d.pageType, { SEARCH: "다른 검색어로 다시 시도하거나 아래 상품을 둘러보세요", other: "" }); },
    emptyListGoTo: function(d) { return select(d.pageType, { other: "" }); },
    loadMore: function(d) { return "상품 더 보기"; },
    youHaveViewed: function(d) { return " " + d.totalProducts + "개 상품 중 " + d.totalNumberOfViewedProducts + "개를 보셨습니다."; },
    loadPrevious: function(d) { return "다시보기"; },
    saleToggle: function(d) { return " " + select(d.pageType, { DESIGNER: d.designerName + " 세일 쇼핑", other: "모든 " + d.designerName + " 상품 쇼핑" }); },
    notifyTitle: function(d) { return "죄송합니다."; },
    continueLink: function(d) { return "신상품 쇼핑하기"; },
    wishList: {
      title: function(d) { return "위시리스트에 추가하기"; },
      subtitle: function(d) { return "원하시는 상품을 추가하고 언제든지 확인해 보세요"; },
      goToWishlist: function(d) { return "위시리스트로 이동하기"; }
    }
  },
  contentHeader: {
    viewMoreCopy: function(d) { return " 더 보기"; },
    sale: function(d) { return " 세일"; }
  },
  collapsableContent: {
    viewMore: function(d) { return " 더 보기"; },
    viewLess: function(d) { return " 숨기기"; }
  },
  sizes: {
    sizeLabel: function(d) { return " 사이즈"; },
    oneSizeLabel: function(d) { return " 원사이즈"; },
    initialValue: function(d) { return "사이즈를 선택해 주세요"; },
    sizeConversion: function(d) { return " 사이즈 " + d.sizeLabel + "은/는 " + d.localLanguageType + " " + d.localSizeValue + "에 해당합니다."; },
    sizeConversionModal: function(d) { return " **" + d.sizeLabel + "** 사이즈는 " + select(d.isSelected, { true: "**" + d.preferredSize + "**", other: d.preferredSize }) + "에 해당합니다"; },
    sizeGuide: {
      viewProductMeasurements: function(d) { return " 사이즈 가이드"; },
      viewSizeGuide: function(d) { return " 사이즈 가이드"; },
      measuringGuide: function(d) { return " 사이즈 및 치수"; },
      title: function(d) { return " 사이즈 가이드"; },
      sizeMeasurementsTitle: function(d) { return " 치수"; },
      sizeMeasurementsDetails: function(d) { return " 완벽한 사이즈를 찾으실 수 있도록 각 의상의 치수를 수작업으로 측정하고 있습니다."; },
      sizeConversionsTitle: function(d) { return " 사이즈 정보"; },
      sizeConversionsDetails: function(d) { return " 사이즈 선택에 어려움이 있으면 다음을 참고하세요."; },
      slideToScroll: function(d) { return " 슬라이드하여 스크롤"; },
      noFurtherInfo: function(d) { return " 더 이상의 사이즈 정보가 없습니다."; },
      unavailable: function(d) { return " 이용 불가"; },
      cm: function(d) { return "cm"; },
      "in": function(d) { return " 인치"; },
      compareSize: {
        text: function(d) { return ""; },
        subText: function(d) { return ""; }
      },
      inStock: function(d) { return " 재고 있음"; },
      lowStock: function(d) { return " 재고 적음"; },
      oneLeft: function(d) { return " 마지막 상품"; },
      outOfStock: function(d) { return " 재고 없음"; }
    },
    watchSizeGuide: {
      title: function(d) { return ""; }
    }
  },
  seo: {
    azdesigners: {
      title: function(d) { return " 패션 디자이너별 쇼핑 | THE OUTNET"; },
      description: function(d) { return ""; },
      keywords: function(d) { return ""; }
    },
    pdpMarkup: {
      nbColours: function(d) { return plural(d.copy, 0, en, { "1": ", " + d.color1 + " 색상 구매 가능. ", "2": ", " + d.color1 + " 또는 " + d.color2 + " 색상 구매 가능. ", other: ", " + number(d.copy, "copy") + "가지 색상 구매 가능. " }); },
      productDescription: function(d) { return d.color + " 색상 " + d.name + ". 사이즈: " + d.size + ". " + select(d.material, { undefined: "", other: "소재: " + d.material }); }
    },
    plpMarkup: {
      name: function(d) { return select(d.category, { undefined: d.designerName, other: d.designerName + " " + d.category }); }
    }
  },
  error: {
    notFound: function(d) { return " 죄송합니다. 페이지를 찾을 수 없습니다."; },
    unknownError: function(d) { return " 오류가 발생했습니다."; },
    goBack: function(d) { return " 돌아가기"; }
  },
  retry: {
    title: function(d) { return " 죄송합니다. 이 페이지를 이용할 수 없습니다."; },
    retrynow: function(d) { return " 지금 다시 시도하세요"; },
    timetoretry: function(d) { return " " + d.seconds + "초 이내에 다시 연결을 시도합니다."; },
    retryingnow: function(d) { return " 지금 다시 시도 중입니다"; }
  },
  accordionTitles: {
    editorsNotes: function(d) { return " 에디터의 노트"; },
    sizeAndFit: function(d) { return " 사이즈 & 핏"; },
    technicalSpecification: function(d) { return " 기술 사양"; },
    detailsAndCare: function(d) { return " 디테일 & 취급 방법"; },
    technicalDescription: function(d) { return " 디테일"; },
    deliveryAndReturns: function(d) { return "배송 & 반품"; }
  },
  accordionIds: {
    editorsNotes: function(d) { return "EditorNotes"; },
    sizeAndFit: function(d) { return "SizeAndFit"; },
    detailsAndCare: function(d) { return " 디테일"; },
    technicalDescription: function(d) { return "DetailsAndCare"; }
  },
  sizeAndFit: {
    sizeDetails: function(d) { return select(d.slash, { slash: " / " + d.label + d.uom, other: d.label + d.uom }); }
  },
  detailsAndCare: {
    imported: function(d) { return " 수입된 아이템입니다."; },
    madeIn: function(d) { return " " + d.madeIn + " 제조"; }
  },
  notifications: {
    PAGE_NOT_AVAILABLE: {
      title: function(d) { return " 죄송합니다."; },
      message: function(d) { return " 고객님은 현재 이 세일을 이용하실 수 없습니다. 대신 숨겨진 보석같은 수많은 신상품이 준비되어 있습니다. 기다리시는 동안 최신 상품을 둘러보시겠어요?"; }
    },
    PAGE_CLOSED: {
      title: function(d) { return " 죄송합니다."; },
      message: function(d) { return " 죄송합니다. 현재 세일이 종료되었습니다. 대신 숨겨진 보석같은 수많은 신상품이 준비되어 있습니다."; }
    },
    PAGE_SOON: {
      title: function(d) { return " 아직입니다!"; },
      message: function(d) { return " 일찍 일어난 새가 벌레를 잡는다고 하지만 너무 일찍 오셨어요. 기다리시는 동안 최신 상품을 둘러보시겠어요?"; }
    },
    ADD_TO_BAG_MESSAGE_ERROR: function(d) { return " 쇼핑백에 추가 실패"; },
    authToAdd: function(d) { return " 이 아이템을 위시리스트에 추가하려면 회원으로 가입하거나 로그인 하세요."; },
    promoPriceSuccess: function(d) { return "프로모션 코드가 복사 되었습니다"; },
    errors: function(d) { return " " + select(d.error, { ADD_TO_WISHLIST_NO_SIZE_SELECTED_ERROR: " 사이즈를 선택하세요.", ERR_WISH_LIST_NOT_EXISTS: " 이 위시리스트는 삭제되었습니다. 이 아이템을 다른 위시리스트에 추가하세요. ", ERR_WISH_LIST_MAX_WISH_LIST_ITEMS_REACHED: " 위시리스트에 저장 가능한 최대 아이템 수에 도달했습니다. 아이템을 추가하려면 저장된 아이템 일부를 삭제하세요. ", ERR_SKU_ALREADY_EXISTS: " 이미 위시리스트에 저장된 아이템입니다 ", NO_SIZE_SELECTED_ERROR: " 사이즈를 선택하세요. ", TEMPORARY_ADD_TO_CART_ERROR: " 죄송합니다. 이 아이템이 쇼핑백에 추가되지 않았습니다. 다시 시도하세요. ", ADD_TO_CART_IDENTITY_GENERIC_ERROR: " 죄송합니다. 이 아이템이 쇼핑백에 추가되지 않았습니다. 다시 시도하세요. ", ADD_TO_CART_GENERIC_ERROR: " 죄송합니다. 이 아이템이 쇼핑백에 추가되지 않았습니다. 다시 시도하세요. ", CART_ITEM_OUT_OF_STOCK: "죄송합니다. 이 아이템은 품절되었습니다 ", CART_ITEM_INSUFFICIENT_STOCK: " 죄송합니다. 이 아이템은 더 이상 재고가 없습니다. ", CART_ORDER_LINE_QTY_LIMIT: "죄송합니다. 쇼핑백에 담을 수 있는 최대 아이템 수에 도달했습니다.", CART_ORDER_LINES_LIMIT: "죄송합니다. 쇼핑백에 담을 수 있는 최대 아이템 수에 도달했습니다.", NO_UBER_TOKEN_ERROR: "", other: "요청을 수행할 수 없습니다. 다시 시도하세요." }); }
  },
  promoPrice: {
    codeDescription: function(d) { return "코드 사용하기"; },
    promotionalPrice: function(d) { return "할인 가격"; }
  },
  shopMore: {
    title: function(d) { return "상품 더 보기"; }
  },
  wearItWith: {
    heading: function(d) { return " 매치 아이템"; }
  },
  youMayAlsoLike: {
    heading: function(d) { return " 추천 아이템"; }
  },
  soldOutReducedPage: {
    heading: function(d) { return "비슷한 상품"; }
  },
  recentlyViewed: {
    heading: function(d) { return "최근 본 상품"; }
  },
  moreByThisDesigner: {
    heading: function(d) { return "More By This Designer"; }
  },
  noResultsSearchPage: {
    dividerHeading: function(d) { return "고객님께 추천해 드리는 인기 아이템"; }
  },
  designers: {
    pageName: function(d) { return " 디자이너"; },
    favorite: function(d) { return " 선호 디자이너"; },
    mens: function(d) { return " 남성"; },
    womens: function(d) { return " 여성"; }
  },
  designersWithSale: {
    pageName: function(d) { return " 디자이너 세일"; }
  },
  deliveryAndReturns: {
    title: function(d) { return " 배송 & 반품"; },
    description: function(d) { return " 배송 옵션과 교환 및 반품 방법에 대해 알아보세요."; },
    shippingModesIntro: function(d) { return " 배송 옵션은 다음과 같습니다."; },
    shippingMode: function(d) { return " " + select(d.shipModeCode, { STANDARD: " 스탠다드 ", EXPRESS: " 익스프레스 ", NEXT_DAY_DELIVERY: " 익일 배송 ", PREMIER_DAYTIME: " 프리미어 낮 시간 ", PREMIER_EVENING: " 프리미어 저녁 시간 ", other: "" }); },
    returnsInfo: function(d) { return " 구매하신 상품은 배송일로부터 " + select(d.country, { RU: "100", UA: "100", BY: "100", other: "28" }) + "일 이내에 언제든지 교환 또는 반품하실 수 있습니다."; },
    findOutMoreLink: function(d) { return " 자세히 보기"; }
  },
  errors: {
    empty: function(d) { return " 이 항목은 필수입니다."; },
    invalid: function(d) { return " 유효한 " + d.field + "을/를 입력하세요."; }
  },
  accountUtility: {
    signupMessage: function(d) { return "향후 세일 및 기타 이벤트 소식을 받아보시려면 이메일 뉴스레터를 신청하세요."; },
    submit: function(d) { return " 제출"; },
    emailLabel: function(d) { return " 이메일 주소"; }
  },
  recommendations: {
    viewSimilarItems: function(d) { return "상품 더 보기"; }
  },
  manufacturerDetails: {
    title: function(d) { return "Manufacturing Details"; },
    subtitle: function(d) { return "MANUFACTURER INFORMATION"; },
    button: function(d) { return "View manufacturing details"; },
    content: function(d) { return "We have no information on this product at the moment, but we're working to include them in the near future.\n\nPlease check back later for updates."; }
  }
}